export const NETWORK_ERRORS = [
    'EAI_AGAIN',
    'ENETUNREACH',
    'ESOCKETTIMEDOUT',
    '504',
];
